import { render, staticRenderFns } from "./EmbeddedChat.vue?vue&type=template&id=1954bb34&"
import script from "./EmbeddedChat.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports